import { createContext, useContext } from 'react';

interface ProficiencyContextProps {
    isCEFR: boolean;
    sectionSlug: string;
}

const initialContextValues = {
    isCEFR: false,
    sectionSlug: '',
};

export const ProficiencyContext = createContext<ProficiencyContextProps>(initialContextValues);

export const useProficiencyContext = () => useContext(ProficiencyContext);
